import { render, staticRenderFns } from "./ModalBankSettings.vue?vue&type=template&id=3efbc820&scoped=true&"
import script from "./ModalBankSettings.vue?vue&type=script&lang=js&"
export * from "./ModalBankSettings.vue?vue&type=script&lang=js&"
import style0 from "./ModalBankSettings.vue?vue&type=style&index=0&id=3efbc820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efbc820",
  null
  
)

export default component.exports